import { Component, Input, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameDayRootReducerState } from '../../../state/root.state';
import { getGamedayFiltersState } from '../../../state/data/reducer';
import { FilterByStock } from '../../../state/data/actions';

@Component({
  selector: 'muni-gameday-stock-toggle',
  templateUrl: './stock-toggle.template.html',
  styleUrls: ['./stock-toggle.styles.scss'],
  standalone: false,
})
export class StockToggleComponent implements OnDestroy {
  @Input()
  public label = '';

  public readonly change: Subject<boolean> = new Subject<boolean>();

  public readonly checked: Observable<boolean> = this.store.pipe(
    select(getGamedayFiltersState),
    map(({ ignoreStocks }) => !ignoreStocks)
  );

  private readonly changeSubscription: Subscription = this.change
    .asObservable()
    .subscribe((selected: boolean) =>
      this.store.dispatch(new FilterByStock(!selected))
    );

  constructor(private store: Store<GameDayRootReducerState>) {}

  public ngOnDestroy(): void {
    this.changeSubscription.unsubscribe();
  }
}
